module.exports = __webpack_public_path__ + "assets/img/tips.62e9031f.png";